import React from 'react'
import ReactDOM from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import App from './App.jsx'
import { iniciarModoPantalla } from './lib/modoPantalla'
import './index.css'

// Antes del primer render: si el usuario eligió modo sol/oscuro, que no parpadee en claro.
iniciarModoPantalla()

// Autoupdate y limpieza de caché Service Worker para nuevos despliegues
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.update()
    }
  })
}

// Preload error handler para evitar bundles desincronizados
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  const KEY = 'reloaded-after-preload-error'
  const last = Number(sessionStorage.getItem(KEY) || 0)
  if (Date.now() - last > 5000) {
    sessionStorage.setItem(KEY, String(Date.now()))
    window.location.reload()
  }
})

registerSW({
  immediate: true,
  onNeedRefresh() {
    window.location.reload()
  },
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return
    registration.update()
    setInterval(() => registration.update(), 10 * 1000)
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
